import { render, staticRenderFns } from "./legendAddModal.vue?vue&type=template&id=092c1909&scoped=true"
import script from "./legendAddModal.vue?vue&type=script&lang=js"
export * from "./legendAddModal.vue?vue&type=script&lang=js"
import style0 from "./legendAddModal.vue?vue&type=style&index=0&id=092c1909&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092c1909",
  null
  
)

export default component.exports